import React from 'react'
import TimerApp from '../../../Pages/TimerApp'

const TimeTracker = () => {
  return (
    <div><TimerApp/></div>
  )
}

export default TimeTracker